import { useState } from 'react'
import { cover } from '../../utility/constant/helper.constant'
import {
  TEnginePosition,
  TEngineType,
  TFabricColor,
  TMarqueeType,
} from '../../utility/type/terraceCover.type'

/**
 * Values and methods are used by the context API
 * @returns states being used to manipulate the scene
 */

export const useStateMarquee = () => {
  const [marquee, setMarquee] = useState<TMarqueeType>(
    cover.terraceCover.marquee
  )
  const [engine, setEngine] = useState<TEngineType>(cover.terraceCover.engine)
  const [enginePosition, setEnginePosition] = useState<TEnginePosition>(
    cover.terraceCover.enginePosition
  )
  const [fabric, setFabric] = useState<TFabricColor>(
    cover.terraceCover.fabricColor
  )

  const onHandleMarquee = (value: TMarqueeType) => {
    setMarquee(value)
  }

  const onHandleEngine = (value: TEngineType) => {
    setEngine(value)
  }

  const onHandleEnginePosition = (value: TEnginePosition) => {
    setEnginePosition(value)
  }

  const onHandleFabric = (value: TFabricColor) => {
    setFabric(value)
  }

  return {
    marquee: {
      type: marquee,
      engine,
      enginePosition,
      fabric,
    },

    marqueeMethod: {
      onHandleMarquee,
      onHandleEngine,
      onHandleEnginePosition,
      onHandleFabric,
    },
  }
}
